export class TableEnvironment {
    static FLOAT_TYPE: string = "Float";
    static STRING_TYPE: string = "String";
    static BOOLEAN_TYPE: string = "Boolean";
    static OBJECT_TYPE: string = "Object";
    static INT_TYPE: string = "Int";

    static lstTypeAllowForm: string[] = [ TableEnvironment.FLOAT_TYPE, TableEnvironment.STRING_TYPE, 
        TableEnvironment.BOOLEAN_TYPE, TableEnvironment.OBJECT_TYPE, TableEnvironment.INT_TYPE ];
}